import styled from "styled-components";
import { COLORS, SCROLLBAR_STYLES } from "../../../../constants/Styles";
import Button from "../../../common/Button";

export const PlacementToolContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const ElementList = styled.div`
  overflow-y: scroll;
  max-height: 20rem;
  background: ${COLORS.tableBackground};
  ${SCROLLBAR_STYLES}
`;

export const ElementListItem = styled.div<{ selected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0.25rem 1rem 0.25rem 0.25rem;
  background: ${({ selected }) => (selected ? COLORS.badgeGray : "default")};
`;

export const Toolbar = styled.div`
  max-height: 100%;
  padding: 1rem 0;
  width: 18rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ToolbarButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

export const AdvancementButton = styled(Button)`
  width: 8rem;
`;
